@if (content) {
  <app-layout-default>
    <app-contact-us [content]="content.contactUs"></app-contact-us>
    <app-checklist [showHeading]="false" [checklistContentInput]="content.checklist" [showPhoneNumber]="false">
    </app-checklist>
    <div class="additional-links">
      <div class="additional-links-header bottom-border">
        <img src="assets/images/cursor-icon.svg" alt="blue cursor icon with lines to indicate clicking links"/>
        <p class="c11n-text-md-bold"
        [innerHTML]="content.additionalLinks.header" data-cy="additional-links-header"></p>
      </div>
      <div class="link-cards-container">
        <div class="gifting">
          <a class="c11n-text-sm" c11n-link variant="primary-reinforced" [href]="content.additionalLinks.gifting.href" target="_blank"
          aria-describedby="link-new-window" data-cy="gifting-link-title" (click)="adobeTrackingForCTA('link', 'gifts')">{{content.additionalLinks.gifting.title}}</a>
          <p class="c11n-text-sm padding-top-1"
          [innerHTML]="content.additionalLinks.gifting.description" data-cy="gifting-link-description"></p>
        </div>
        <div class="retirement">
          <a class="c11n-text-sm" c11n-link variant="primary-reinforced" [href]="content.additionalLinks.retirement.href" target="_blank"
          aria-describedby="link-new-window" data-cy="retirement-link-title" (click)="adobeTrackingForCTA('link', 'retirement')">{{content.additionalLinks.retirement.title}}</a>
          <p class="c11n-text-sm padding-top-1"
          [innerHTML]="content.additionalLinks.retirement.description" data-cy="retirement-link-description"></p>
        </div>
        <div class="cash">
          <a class="c11n-text-sm" c11n-link variant="primary-reinforced" [href]="content.additionalLinks.cash.href" target="_blank"
          aria-describedby="link-new-window" data-cy="cash-link-title" (click)="adobeTrackingForCTA('link', 'cash_plus')">{{content.additionalLinks.cash.title}}</a>
          <p class="c11n-text-sm padding-top-1"
          [innerHTML]="content.additionalLinks.cash.description" data-cy="cash-link-description"></p>
        </div>
        <div class="external">
          <a class="c11n-text-sm" c11n-link variant="primary-reinforced" [href]="content.additionalLinks.external.href" target="_blank"
          aria-describedby="link-new-window" data-cy="external-link-title" (click)="adobeTrackingForCTA('link', 'transfer_of_assets')">{{content.additionalLinks.external.title}}</a>
          <p class="c11n-text-sm padding-top-1"
          [innerHTML]="content.additionalLinks.external.description" data-cy="external-link-description"></p>
        </div>
      </div>
    </div>
    <div layout-last-column>
      <c11n-button id="ineligibleBTN" (clickEvent)="learnMore()" [labelText]="content.buttonLabel" fullWidth="true">
      </c11n-button>
      <app-feedback-survey></app-feedback-survey>
    </div>
  </app-layout-default>
}
